import React, { useState } from "react";
import { rem } from "polished";
import styled from "styled-components";

const OldPrice = styled.div`
    font-family: sans-serif;
    font-size: ${rem(13)};
    color: #282a2c;
    line-height: ${rem(22.5)};

    b {
        font-weight: 700;
        font-size: ${rem(15)};
        text-decoration-line: line-through;
    }
`;
const NewPrice = styled.div`
    font-family: sans-serif;
    color: #962d27;
    font-weight: 700;
    font-size: ${rem(14)};
    line-height: ${rem(27)};

    b {
        font-size: ${rem(18)};
    }
`;
const Wrap = styled.div`
    margin-bottom: ${rem(35)};
`;

const Price = ({ oldPrice, newPrice }) => {
    return (
        <Wrap>
            <OldPrice>
                SRP: <b>£{oldPrice}</b>
            </OldPrice>
            <NewPrice>
                <b>£{newPrice}</b> You Save £{oldPrice - newPrice}
            </NewPrice>
        </Wrap>
    );
};

export default Price;
